

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M8.5 13.3206L10.9615 15.9873L16.5 9.9873M21.5 12.9873C21.5 17.9579 17.4706 21.9873 12.5 21.9873C7.52944 21.9873 3.5 17.9579 3.5 12.9873C3.5 8.01674 7.52944 3.9873 12.5 3.9873C17.4706 3.9873 21.5 8.01674 21.5 12.9873Z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}, []), "\n"]);
};

        